import { useContext } from 'react';

import { route } from './constants';
import { ApplicationContext } from '../../../../../shared/source/context/context';

export type TabParam = 'employees' | 'jobs' | 'learningOpportunities' | 'skills';

const defaultTabParam: TabParam = 'skills';
const tabParamValues: readonly TabParam[] = ['skills', 'employees', 'jobs', 'learningOpportunities'] as const;

const { tabParam } = route.searchParams;

const isValidSearchParam = (value: string | null): value is TabParam =>
    typeof value === 'string' && tabParamValues.includes(value as TabParam);

export const useTalentDirectoryParams = (): {
    readonly getSearchParamsForTab: (tab: TabParam) => URLSearchParams;
    readonly tableTabParam: TabParam;
} => {
    const {
        applicationState: { locationSearchParams },
    } = useContext(ApplicationContext);
    const tabParamValue = locationSearchParams.get(tabParam);
    const tableTabParam = isValidSearchParam(tabParamValue) ? tabParamValue : defaultTabParam;

    const getSearchParamsForTab = (tab: TabParam): URLSearchParams => {
        const search = new URLSearchParams(locationSearchParams);
        search.delete('page');
        search.delete('pageSize');

        search.set(tabParam, tab);

        return search;
    };

    return { getSearchParamsForTab, tableTabParam };
};

export const defaultPagination = { count: 0, page: 0, pages: 0, size: 0 };
